import {
  ApiGetRequest,
  // ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Report - NAT Container',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - NAT Container',
        href: '/adm/opr/report/nat-container',
        active: true,
      },
    ],
    showmodal: false,
    items: [
      {
        id: '1',
        code: 'ABS',
        container: 'DRYU2212231',
        size: 20,
        type: 'GP',
        booking: 'DXB16672SUG',
        doc_no: 'SUB.EIRIN.20.000523',
        date_in: '10/12/2020 10:11',
        ex_vessel: 'Infinity',
        ex_voy: 'S008',
        vessel: 'KM12',
      },
      {
        id: '2',
        code: 'ABS',
        container: 'DRYU2212231',
        size: 20,
        type: 'GP',
        booking: 'DXB16672SUG',
        doc_no: 'SUB.EIRIN.20.000523',
        date_in: '10/12/2020 10:11',
        ex_vessel: 'Infinity',
        ex_voy: 'S008',
        vessel: 'KM12',
      },
      {
        id: '3',
        code: 'ABS',
        container: 'DRYU2212231',
        size: 20,
        type: 'GP',
        booking: 'DXB16672SUG',
        doc_no: 'SUB.EIRIN.20.000523',
        date_in: '10/12/2020 10:11',
        ex_vessel: 'Infinity',
        ex_voy: 'S008',
        vessel: 'KM12',
      },
    ],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_principle',
    sortDesc: true,
    fields: [
      {
        key: 'code',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'date_in',
        label: 'Date In',
        sortable: true,
      },
      {
        key: 'survey_date',
        label: 'Survey Date',
        sortable: true,
      },
      {
        key: 'eor_date',
        label: 'EOR Date',
        sortable: true,
      },
      {
        key: 'nat_date',
        label: 'NAT Date',
        sortable: true,
      },
      {
        key: 'ex_vessel',
        label: 'Ex Vessel',
        sortable: true,
      },
      {
        key: 'ex_voy',
        label: 'Ex Voy',
        sortable: true,
      },
    ],
    detail: false,
    form: {
      code: '',
      name: '',
      address: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      email: '',
      phone: '',
      fax: '',
      free_storage: '',
      add_storage: '',
      min_storage: '',
      max_storage: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportContNat(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListPrinciple({ commit, state, dispatch }) {
    commit('reportContNat', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/principle`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('reportContNat', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getDetailPrinciple({ commit, state, dispatch }, payload = null) {
    commit('reportContNat', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/principle/${payload.id}`,
      state.data.form
    );
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
        error: result.error,
      });
      return false;
    } else {
      commit('reportContNat', {
        loading: false,
      });
      return true;
    }
  },

  async createPrinciple({ state }) {
    console.log(JSON.stringify(state.data.form));
    return true;
    // commit('reportContNat', {
    //   loading: true,
    // });

    // let result = await ApiPostRequest(`opr/principle`, state.data.form);

    // showNotif(dispatch, {
    //   message: result.message,
    //   type: result.error ? 'error' : 'success',
    //   error: result.error ? result.error : false,
    // });

    // if (result.error) {
    //   return false;
    // } else {
    //   commit('reportContNat', {
    //     loading: false,
    //   });
    //   return true;
    // }
  },

  async updatePrinciple({ commit, state, dispatch }, payload = null) {
    commit('reportContNat', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/principle/${payload.id}`,
      state.data.form
    );

    showNotif(dispatch, {
      message: result.message,
      type: result.error ? 'error' : 'success',
      error: result.error ? result.error : false,
    });

    if (result.error) {
      return false;
    } else {
      commit('reportContNat', {
        loading: false,
      });
      return true;
    }
  },

  async deletePrinciple({ commit, dispatch }, payload = null) {
    commit('reportContNat', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/principle/${payload.id}`);
    showNotif(dispatch, {
      message: result.message,
      type: result.error ? 'error' : 'success',
      error: result.error ? result.error : false,
    });

    if (result.error) {
      return false;
    } else {
      commit('reportContNat', {
        loading: false,
      });
      return true;
    }
  },
};
